import React from 'react';

import { Rect } from '@repo/ui/components/Loader';

import { FlexRow } from 'styles/layouts';

import { SkeletonProps } from './types';

const Skeleton: React.FC<SkeletonProps> = ({ rects }) => (
  <FlexRow flexWrap="wrap" gap="4px" width="inherit">
    {rects.map((style, index) => (
      <Rect key={index} style={style} />
    ))}
  </FlexRow>
);

export default Skeleton;
